import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import {
  $getRoot,
  LexicalEditor,
  NodeKey,
  RangeSelection,
  TextNode,
} from 'lexical';
import { $getAllFootnoteNodes } from '../nodes/FootNotes';

export function FootnoteNumberingPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    // This listener triggers on every editor update
    const unregister = editor.registerUpdateListener(({ dirtyLeaves, prevEditorState, editorState }) => {
      // Update footnote numbers only if a footnote node was added or removed
      let footnoteChanged = false;

      editorState.read(() => {
        const prevNodes: NodeKey[] = [];
        prevEditorState.read(() => {
          $getAllFootnoteNodes().forEach((node) => prevNodes.push(node.getKey()));
        });

        const currentNodes = $getAllFootnoteNodes().map((n) => n.getKey());
        if (prevNodes.length !== currentNodes.length) {
          footnoteChanged = true;
        } else {
          for (let i = 0; i < prevNodes.length; i++) {
            if (prevNodes[i] !== currentNodes[i]) {
              footnoteChanged = true;
              break;
            }
          }
        }
      });

      if (footnoteChanged) {
        // Recalculate numbers for all footnotes
        editor.update(() => {
          const nodes = $getAllFootnoteNodes();
          nodes.forEach((node, index) => {
            const writable = node.getWritable();
            // Trigger a re-render by updating the content with the same value
            writable.__number = index + 1;
          });
        });
      }
    });

    return () => unregister();
  }, [editor]);

  return null;
}

// Optionally, you could extend FootnoteNode to store `__number`
// for rendering in the decorator:
